import * as Yup from 'yup';
import { ERRORS } from '../constants/base';
import { emailRegex } from '../regex';
import { manualAddressFieldTests } from './manualAddressRules';
import { phonesArraySchema } from './phoneRules';

// Notification review forms receive addresses that originated from the mobile app or
// backend and may have an empty place_id (not selected via Google Places autocomplete).
// We only require the address type — place_id is not enforced here. A reviewer CAN toggle
// manual and hand-enter an address here (Person → Address / LeftTown), so the shared manual
// rules (in-range coordinates + seeded region) apply identically to the front-office forms.
const addressSchemaForReview = Yup.object().shape({
    type: Yup.string().required(ERRORS.required),
    place_id: Yup.string().nullable(),
    ...manualAddressFieldTests(),
});

// Notification review forms receive person data from the mobile app or backend.
// Phones may be absent (no read_contact_info permission) or empty (person has no phone).
// We do not require a phone number here — the reviewer can save the person as-is.
export const personSchema = Yup.object().shape({
    salutation: Yup.string().nullable(),
    first_name: Yup.string().required(ERRORS.required).min(1, ERRORS.required),
    last_name: Yup.string().required(ERRORS.required),
    gender: Yup.string().nullable(),
    email: Yup.string().matches(emailRegex, ERRORS.email).nullable(),
    addresses: Yup.array().of(addressSchemaForReview),
    // A number is still not REQUIRED here (the reviewer can save the person as-is), but a
    // number that IS present has to look like one — the API applies the same rule, so
    // without this the reviewer gets a 422 instead of a field error.
    phones: phonesArraySchema(),
})